<template>
  <div>
    <div v-if="loadingNotes">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <v-row class="mt-1 mr-2">
      <v-col cols="12" sm="8">
        <div v-if="notes.length === 0">No notes were found for customer.</div>
      </v-col>
      <v-col class="d-flex justify-end">
        <v-btn
          min-width="36"
          color="primary"
          @click="$emit('toggle-addnote', customer.id)"
        >
          <v-icon>mdi-pen-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-timeline density="compact" align="start">
      <v-timeline-item v-for="note in notes" :key="note.date" size="x-small">
        <div class="mb-4">
          <note-header :note="note"></note-header>
          <note-services :note="note"></note-services>
          <note-text :note="note"></note-text>
        </div>
      </v-timeline-item>
    </v-timeline>
  </div>
</template>

<script>
import axios from "axios";
import NoteText from "./NoteText.vue";
import NoteServices from "./NoteServices.vue";
import NoteHeader from "./NoteHeader.vue";

export default {
  name: "RenderNotes",
  components: {
    NoteText,
    NoteServices,
    NoteHeader,
  },
  props: {
    customer: {
      type: Object,
      required: true,
    },
  },
  emits: ["toggle-addnote"],
  setup() {
    const apiURL = import.meta.env.VITE_API_URL;
    return { apiURL };
  },
  data() {
    return {
      notes: [],
      loadingNotes: true,
    };
  },
  mounted() {
    this.loadNotes(this.customer.id);
  },
  methods: {
    async loadNotes(customerId) {
      const response = await axios.get(this.apiURL + "notes", {
        params: {
          customer_id: customerId,
        },
      });
      this.notes = response.data.notes.sort((a, b) => {
        return new Date(b.updated_at) - new Date(a.updated_at);
      });
      this.loadingNotes = false;
    },
  },
};
</script>
